import { type PimProductWithVariantsV1 } from '@redteclab/api/clients/bully'

/**
 * variant code, aka "product family id", this identifier is shared by the variants
 * of same meta product.
 * e.g. Bepanthen with variants 50g, 100g, 200g, all of them share the same variant code.
 */
export const productAccessorGetVariantCode = (
  product: PimProductWithVariantsV1,
): string | undefined => {
  return product.variant_code
}
